import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  checkingStatus: boolean
  onStatusCheck: () => void
  pendingState: boolean
}

const Pending = ({ checkingStatus, onStatusCheck, pendingState }: Props) => {
  const resolveTitle = () => {
    if (pendingState) {
      return i18n.t('payroll_integrations.incidences.datev_lauds.termination.pending.waiting_title')
    } else {
      return i18n.t('payroll_integrations.incidences.datev_lauds.termination.pending.title')
    }
  }
  return (
    <>
      <Box gap="s4" flexDirection="row">
        <Icon.Medium icon="spinner" color="viridian1000" />
        <Text.Header2>{resolveTitle()}</Text.Header2>
      </Box>
      <Box gap="s4">
        {i18n.t('payroll_integrations.incidences.datev_lauds.termination.pending.message')}
      </Box>
      <Button onClick={onStatusCheck} disabled={checkingStatus}>
        {i18n.t('payroll_integrations.incidences.datev_lauds.termination.pending.status_check')}
      </Button>
    </>
  )
}

export default Pending
